import PmaxAssetGroupPage from '@/components/google-ads/performance-max/PmaxAssetGroupPage';
import { LOCAL_OBJECTIVE } from './localObjective';

/** ADD ASSET GROUPS TO A LOCAL CAMPAIGN — /google-ads/local/create/assetgroup */
export default function CreateLocalAssetGroup() {
  return <PmaxAssetGroupPage objective={LOCAL_OBJECTIVE} />;
}
